import { getActualAngle } from '@/utils/math-kit';

/**
 * 计算旋转后的基础操作鼠标索引
 *
 * @param rotate - 旋转角度
 * @param count - 计数
 */
export const useGetCursorIndex = (rotate: number, count?: number) => {
    const newRotate = getActualAngle(rotate, 22.5);
    let cursorIndex;
    if (count) {
        cursorIndex = ~~(newRotate / 45) % count;
    } else {
        cursorIndex = ~~(newRotate / 45);
    }
    return cursorIndex;
};
